import './App.css';
import Quote from './features/quote/Quote';
import GsapBasic from './components/GsapBasic';


function App() {
  return (
    <div>
      <header>
        <Quote/>
        <GsapBasic/>
      </header>
    </div>
  );
}

export default App;
